import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { ImpersonationBanner } from '@/components/impersonation-banner';
import { NavigationMenu } from '@/components/layout/navigation-menu';
import { Toaster } from '@/components/ui/sonner';
import { TakeoffSummaryProvider } from '@/lib/data';
import { TakeoffSystemProvider } from '@/lib/markup-designer/shared/takeoff-system-ui-state/use-takeoff-system-client';

type Props = {
  children?: ReactNode;
};

export const ProtectedLayout = ({ children }: Props) => {
  return (
    <TakeoffSummaryProvider>
      <TakeoffSystemProvider>
        <ImpersonationBanner />

        <div className='flex flex-col sm:flex-row sm:h-screen'>
          <NavigationMenu />

          <div className='scrollable-container sm:overflow-y-auto flex-1 p-4 sm:p-8'>
            {children ?? <Outlet />}
          </div>
        </div>

        <Toaster />
      </TakeoffSystemProvider>
    </TakeoffSummaryProvider>
  );
};
